export const WeeklyTimeUnits = {
  Hourly: 'Hourly',
  Daily: 'Daily',
} as const;
